import React from "react";
import BarGraphFilled from "../../../Components/Icons/BarGraphFilled";
import BarGraphBlank from "../../../Components/Icons/BarGraphBlank";

/**
 * BarGraphIcon
 *
 * Props:
 * - isSelected: boolean -> when true shows GraphFilled, else GraphBlank
 * - style can be passed in for sizing
 */
export default function BarGraphIcon({ isSelected, ...rest }) {
    if (isSelected) {
        return <BarGraphFilled {...rest} />;
    }
    return <BarGraphBlank {...rest} />;
}
